import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.75355 4.66666C8.73157 4.23325 8.81049 3.89848 9.02509 3.61666C9.55812 2.91666 10.6439 2.91666 12.8155 2.91666H15.1845C17.3561 2.91666 18.4419 2.91666 18.9749 3.61666C19.1895 3.89848 19.2684 4.23325 19.2465 4.66666",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.83331 9.33331C5.87746 9.03042 5.97889 8.76857 6.14795 8.53334C6.83073 7.58331 8.24609 7.58331 11.0768 7.58331H16.9231C19.7539 7.58331 21.1692 7.58331 21.852 8.53334C22.0211 8.76857 22.1225 9.03042 22.1666 9.33331",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.45379 18.3316L5.29248 21.0187C6.33726 24.3661 7.23017 25.0833 10.7453 25.0833H17.2547C20.7698 25.0833 21.6627 24.3661 22.7075 21.0187L23.5462 18.3316C24.4138 15.552 24.8476 14.1622 24.1618 13.2061C23.476 12.25 22.0453 12.25 19.1839 12.25H8.81606C5.95467 12.25 4.52398 12.25 3.8382 13.2061C3.15241 14.1622 3.5862 15.552 4.45379 18.3316Z",
      stroke: "white",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }